import ApiHelperService from '../ApiHelperService';

const webAppBaseUrl = process.env.REACT_APP_WEBAPP_API_BASE_URL

const get = (endpoint, headers, options = {}) => {
    return ApiHelperService.get(`${webAppBaseUrl}${endpoint}`, headers, options);
};
//webAppBaseUrl
const post = (endpoint, payload, headers, options = {}) => {
    return ApiHelperService.post(`${webAppBaseUrl}${endpoint}`, payload, headers, options);
};


export default {   
    get,
    post

};